// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2IsHC","box":"WorkspacesBox_box__3kANr","node":"WorkspacesBox_node__3togC"};